const isLinkValid = (
    link: string,
    requireProtocol: boolean = false
): boolean => {
    if (!link) return false
    // Regex para validar URLs

    if (requireProtocol) {
        // Exige http(s):// no início
        return (
            link.length > 0 &&
            /^(https:\/\/|http:\/\/)[\w-]+(\.[\w-]+)+([/\w\- .?%&=]*)?$/.test(
                link
            )
        )
    } else {
        // Permite com ou sem http(s)://
        return (
            link.length > 0 &&
            /^((https:\/\/|http:\/\/)?[\w-]+(\.[\w-]+)+([/\w\- .?%&=]*)?)$/.test(
                link
            )
        )
    }
}

export default isLinkValid
